import { render } from "./ProfileTrends.vue?vue&type=template&id=f06331da&scoped=true"
import script from "./ProfileTrends.vue?vue&type=script&lang=js"
export * from "./ProfileTrends.vue?vue&type=script&lang=js"

import "./ProfileTrends.vue?vue&type=style&index=0&id=f06331da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06331da"]])

export default __exports__